import { useMatch } from 'react-router-dom'

import {
  commentsChannel,
  commentsPage,
  communityChannel,
  communityPage,
} from '~publish/legacy/routes'

/**
 * True when the current URL is any Community inbox route: the legacy
 * /comments/* routes or the new /community and /channels/:channelId/community
 * routes (all-channels, single-channel, and by-post). Used to gate
 * Community-only real-time UI — e.g. the "new items available" pill — so that
 * org-wide Pusher events don't surface it on unrelated pages.
 */
export const useIsCommunityRoute = (): boolean => {
  // Legacy /comments/* routes (kept for the transition to the New IA).
  const commentsPageMatch = useMatch(commentsPage.route)
  const channelPageMatch = useMatch(commentsChannel.route)
  const channelBasePageMatch = useMatch(commentsChannel.baseRoute)
  const specificPostMatch = useMatch(commentsChannel.postsRoute)

  // New /community and /channels/:channelId/community routes (New IA Overhaul).
  const communityPageMatch = useMatch(communityPage.route)
  const communityPostsMatch = useMatch(communityPage.postsRoute)
  const communityByPostMatch = useMatch(communityPage.postDetailRoute)
  const communityChannelPageMatch = useMatch(communityChannel.route)
  const communityChannelBaseMatch = useMatch(communityChannel.baseRoute)
  const communitySpecificPostMatch = useMatch(communityChannel.postsRoute)

  return (
    !!commentsPageMatch ||
    !!channelPageMatch ||
    !!channelBasePageMatch ||
    !!specificPostMatch ||
    !!communityPageMatch ||
    !!communityPostsMatch ||
    !!communityByPostMatch ||
    !!communityChannelPageMatch ||
    !!communityChannelBaseMatch ||
    !!communitySpecificPostMatch
  )
}
